import emojiRegex from 'emoji-regex';

const regex = emojiRegex();
export const removeEmojis = (text) => {
  if (!text) return text;
  if (!regex.test(text)) return text; 
  return text.replace(regex, '');
};
